
<nav class="mobile-navigation-wrapper">
	<ul class="main-navigation">
		<li class="search-route route">
			<a 
				class="main-route-link search link"
				[routerLink]="['/hledat']" 
				routerLinkActive="active"
				matRipple
				title="vyhledávání obsahu"
				>
				<span class="label">
					Hledat
					<span class="under-line-container" ></span>
				</span>
				<app-icon class="search-icon" name="search"></app-icon>
			</a>
		</li>
	  <li class="main-section route" *ngFor="let route of (routes$ | push)">
	    <app-route-link class="section-route-link" [route]="route" ></app-route-link>
	    <ul class="main-routes">
	      <li class="main-route" *ngFor="let subPage of route.children" >
	      	<app-route-link class="main-route-link" [route]="subPage"></app-route-link>
	      </li>
	    </ul>
	  </li>
	  <li class="main-section route">
	  	<app-route-link class="section-route-link" [route]="about"></app-route-link>
	  	<ul class="main-routes">
	  	  <li class="main-route" *ngFor="let subPage of (about$ | push)" routerLinkActive="active">
	  	    <app-route-link class="main-route-link" [route]="subPage"></app-route-link>
	  	  </li>
	  	</ul>
	  </li>
	</ul>
</nav>
